module.exports = __webpack_public_path__ + "static/img/10.6f60b29.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/4/zh/10.png
// module id = z06g
// module chunks = 0